import { tenantService } from "../services/tenantService";
import { useAsyncData } from "./useAsyncData";

export function useTenantDetail(tenantId: string | undefined) {
  return useAsyncData(
    () =>
      tenantId
        ? tenantService.getTenantDetail(tenantId)
        : Promise.resolve({
            tenant: null,
            members: [],
            invites: [],
            featureFlags: [],
            auditLogs: [],
          }),
    [tenantId],
  );
}
